import React from 'react';

const SlickButtonFix = ({currentSlide, slideCount, children, ...props}) => {
	return (
		<span className="slick-arrow slick-next" {...props}>{children}</span>
	);
};

export default SlickButtonFix;